import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../shared/atoms/Box';
import Heading from '../shared/atoms/Heading';
import Link from '../shared/atoms/Link';
import Text from '../shared/atoms/Text';
// Icons
import AngleRight16 from '../icons/AngleRight16';

const DisplayText = ({ title, text }) => (
  <Box mb={5}>
    <Text mb={2} variant="large" fontWeight="bold" color="black">
      {title}
    </Text>
    <Text>{text}</Text>
  </Box>
);

export default function FrequentlyAskedQuestion() {
  const { t } = useTranslation();
  return (
    <Box mt={6} mb={6}>
      <Box flexDirection="row" mb={6}>
        <Heading level={5} mb={4}>
          {t('standalone.faq.title')}
        </Heading>
      </Box>
      <DisplayText
        title={t('standalone.faq.title.1')}
        text={t('standalone.faq.text.1')}
      />
      <DisplayText
        title={t('standalone.faq.title.2')}
        text={t('standalone.faq.text.2')}
      />
      <DisplayText
        title={t('standalone.faq.title.3')}
        text={t('standalone.faq.text.3')}
      />
      <DisplayText
        title={t('standalone.faq.title.4')}
        text={t('standalone.faq.text.4')}
      />
      <Link
        color="blue.electric"
        target="_blank"
        after={<AngleRight16 />}
        href="https://faq.roulezjeunesse.com/">
        {t('standalone.faq.cta')}
      </Link>
    </Box>
  );
}
